import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_SUPPORTER_GROWTH_PSF_RECOMMENDED_GROUPS_EXPERIMENT = createFcmDetails(
	'supporter_growth_psf_recommended_groups_experiment',
	{
		owner: 'Supporter Growth Squad',
		context: 'Post Sign Flow (PSF)',
		description: 'Experiment to test recommended groups in the PSF: https://change.atlassian.net/browse/CHANGE-80699',
		template: {
			experimentName: '',
		},
		import: false,
	},
);
